export const homepageCTAData = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/browseListingIcon.svg",
        route: "/listings",
        directRoute: true,
        title: "Browse Listings",
        body: "View commercial properties currently for sale or lease on Zonado",
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/createListingIcon.svg",
        route: "/add-listing",
        title: "Create a Listing",
        directRoute: false,
        body: "List a property/business for sale or lease on Zonado.",
    },
];